import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-muted",
  style: {"font-size":"12px","margin-top":"4px"}
}, "建议尺寸: 660 × 880 px (3:4 竖图)", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("商城设置")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "ms-2 text-muted",
  style: {"font-size":"12px"}
}, "开启后可在商城直接购买", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "ms-2 text-muted",
  style: {"font-size":"12px"}
}, "每人累计限购「件数」，0 表示不限购", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "ms-2 text-muted",
  style: {"font-size":"12px"}
}, "每人每日限购「件数」，0 表示不限", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "ms-2 text-muted",
  style: {"font-size":"12px"}
}, "需要「当日」流水达到该值才能购买，0 表示不限", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "ms-2 text-muted",
  style: {"font-size":"12px"}
}, "开启后在商城列表中优先显示", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "ms-2 text-muted",
  style: {"font-size":"12px"}
}, "开启后用户可支付尾款", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "ms-2 text-muted",
  style: {"font-size":"12px"}
}, "元", -1)
const _hoisted_13 = {
  class: "ms-2 text-muted",
  style: {"font-size":"12px"}
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-muted",
  style: {"font-size":"12px","margin-bottom":"8px"}
}, "建议宽度 750 px (长图)", -1)
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "el-upload-list__item-actions" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 新增盒中盒赏品 ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 按价格排序 ")
const _hoisted_20 = {
  key: 7,
  class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", null, "商品"),
    /*#__PURE__*/_createElementVNode("th", null, "回收价"),
    /*#__PURE__*/_createElementVNode("th", null, "赏品类型"),
    /*#__PURE__*/_createElementVNode("th", null, "数量"),
    /*#__PURE__*/_createElementVNode("th", null, "操作")
  ])
], -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 上移 ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 下移 ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 删除 ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_plus = _resolveComponent("plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_delete = _resolveComponent("delete")!
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_NewBoxItemInfoModal = _resolveComponent("NewBoxItemInfoModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      rules: _ctx.rules,
      model: _ctx.product,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "图片",
          prop: "image",
          rules: _ctx.rules.image
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_upload, {
              class: "avatar-uploader",
              action: "https://jsonplaceholder.typicode.com/posts/",
              "show-file-list": false,
              "auto-upload": false,
              ref: "uploadRef",
              "on-change": _ctx.onChange
            }, {
              default: _withCtx(() => [
                (_ctx.imageUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.imageUrl,
                      class: "avatar"
                    }, null, 8, _hoisted_2))
                  : (_openBlock(), _createBlock(_component_el_icon, {
                      key: 1,
                      class: "avatar-uploader-icon"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_plus)
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }, 8, ["on-change"]),
            _hoisted_3
          ]),
          _: 1
        }, 8, ["rules"]),
        (_ctx.product.product_type == 'box_normal' || _ctx.product.product_type == 'box_infinity')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              prop: "product_gifts_attributes",
              rules: _ctx.rules.product_gifts_attributes,
              style: {"height":"0","overflow":"hidden","margin":"0","padding":"0"}
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["rules"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: "品牌",
          prop: "product_brand_id"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.product.product_brand_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.product.product_brand_id) = $event)),
              filterable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product_brand_options, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.key,
                    value: item.value,
                    key: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "IP",
          prop: "ip_id"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.product.ip_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.product.ip_id) = $event)),
              filterable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product_ip_options, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.key,
                    value: item.value,
                    key: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "兑换类型",
          prop: "recycle_type",
          rules: _ctx.rules.recycle_type
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.product.recycle_type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.product.recycle_type) = $event)),
              filterable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRecycleTypeOptions, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.key,
                    value: item.value,
                    key: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["rules"]),
        _createVNode(_component_el_form_item, {
          label: "名称",
          prop: "name",
          rules: _ctx.rules.name
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.product.name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.product.name) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["rules"]),
        _createVNode(_component_el_form_item, {
          label: "市场价",
          prop: "price",
          rules: _ctx.rules.price
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.product.price,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.product.price) = $event)),
              step: 0.1,
              precision: 1
            }, null, 8, ["modelValue", "step"])
          ]),
          _: 1
        }, 8, ["rules"]),
        _createVNode(_component_el_form_item, {
          label: "回收价",
          prop: "recycle_price",
          rules: _ctx.rules.recycle_price
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.product.recycle_price,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.product.recycle_price) = $event)),
              step: 0.1,
              precision: 1
            }, null, 8, ["modelValue", "step"])
          ]),
          _: 1
        }, 8, ["rules"]),
        _createVNode(_component_el_form_item, {
          label: "链接",
          prop: "link"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.product.link,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.product.link) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "预售",
          prop: "is_presale"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.product.is_presale,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.product.is_presale) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_ctx.product.is_presale)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: "预计到货日期",
              prop: "arrival_date"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.product.arrival_date,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.product.arrival_date) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: "库存",
          prop: "stock",
          rules: _ctx.rules.stock
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.product.stock,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.product.stock) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["rules"]),
        _createVNode(_component_el_form_item, {
          label: "售卖",
          prop: "is_on_sale"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.product.is_on_sale,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.product.is_on_sale) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "到付",
          prop: "need_shipping_fee"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.product.need_shipping_fee,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.product.need_shipping_fee) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "老带新",
          prop: "is_bundle_gift"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.product.is_bundle_gift,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.product.is_bundle_gift) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "明信片",
          prop: "is_card"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.product.is_card,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.product.is_card) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "允许回收",
          prop: "is_recyclable"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.product.is_recyclable,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.product.is_recyclable) = $event)),
              disabled: _ctx.product.product_type === 'reward_pack'
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "允许合成",
          prop: "is_composable"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.product.is_composable,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.product.is_composable) = $event)),
              disabled: _ctx.product.product_type === 'reward_pack'
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "允许发货",
          prop: "allow_to_deliver"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.product.allow_to_deliver,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.product.allow_to_deliver) = $event)),
              disabled: _ctx.product.product_type === 'reward_pack'
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "活动",
          prop: "event_id"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.product.event_id,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.product.event_id) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event_options, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.name,
                    value: item.id,
                    key: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_ctx.product.event_id != '' && _ctx.product.event_id != null)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              label: "活动点数",
              prop: "event_point",
              rules: _ctx.rules.event_point
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: _ctx.product.event_point,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.product.event_point) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["rules"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: "备注",
          prop: "note"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.product.note,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.product.note) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider, { "content-position": "left" }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "商城商品",
          prop: "is_mall_product"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.product.is_mall_product,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.product.is_mall_product) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_6
          ]),
          _: 1
        }),
        (_ctx.product.is_mall_product)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createVNode(_component_el_form_item, {
                label: "商城库存",
                prop: "mall_stock",
                rules: _ctx.rules.mall_stock
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.product.mall_stock,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.product.mall_stock) = $event)),
                    min: 0
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["rules"]),
              _createVNode(_component_el_form_item, {
                label: "限购数量",
                prop: "purchase_limit"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.product.purchase_limit,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.product.purchase_limit) = $event)),
                    min: 0,
                    "value-on-clear": 0,
                    placeholder: "0表示不限购"
                  }, null, 8, ["modelValue"]),
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "每日限购",
                prop: "daily_purchase_limit"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.product.daily_purchase_limit,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.product.daily_purchase_limit) = $event)),
                    min: 0,
                    "value-on-clear": 0,
                    placeholder: "0表示不限"
                  }, null, 8, ["modelValue"]),
                  _hoisted_8
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "流水要求",
                prop: "water_need"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.product.water_need,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.product.water_need) = $event)),
                    min: 0,
                    "value-on-clear": 0,
                    placeholder: "0表示不限"
                  }, null, 8, ["modelValue"]),
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "置顶显示",
                prop: "is_mall_top"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.product.is_mall_top,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.product.is_mall_top) = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_10
                ]),
                _: 1
              }),
              (_ctx.product.is_presale)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_el_form_item, {
                      label: "已到货",
                      prop: "is_arrived"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.product.is_arrived,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.product.is_arrived) = $event))
                        }, null, 8, ["modelValue"]),
                        _hoisted_11
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "预售支付模式",
                      prop: "presale_payment_mode"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.product.presale_payment_mode,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.product.presale_payment_mode) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "仅全款",
                              value: "full_only"
                            }),
                            _createVNode(_component_el_option, {
                              label: "仅订金",
                              value: "deposit_only"
                            }),
                            _createVNode(_component_el_option, {
                              label: "订金或全款",
                              value: "deposit_or_full"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    (_ctx.product.presale_payment_mode && _ctx.product.presale_payment_mode !== 'full_only')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_el_form_item, {
                            label: "订金类型",
                            prop: "deposit_type"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.product.deposit_type,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.product.deposit_type) = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "固定金额",
                                    value: "fixed"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "百分比",
                                    value: "percent"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          (_ctx.product.deposit_type === 'fixed')
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 0,
                                label: "订金金额",
                                prop: "deposit_amount",
                                rules: _ctx.rules.deposit_amount
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input_number, {
                                    modelValue: _ctx.product.deposit_amount,
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.product.deposit_amount) = $event)),
                                    min: 0,
                                    precision: 2
                                  }, null, 8, ["modelValue"]),
                                  _hoisted_12
                                ]),
                                _: 1
                              }, 8, ["rules"]))
                            : _createCommentVNode("", true),
                          (_ctx.product.deposit_type === 'percent')
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 1,
                                label: "订金比例",
                                prop: "deposit_percent",
                                rules: _ctx.rules.deposit_percent
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input_number, {
                                    modelValue: _ctx.product.deposit_percent,
                                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.product.deposit_percent) = $event)),
                                    min: 1,
                                    max: 100
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("span", _hoisted_13, "%（计算后订金: " + _toDisplayString(_ctx.calculatedDeposit) + " 元）", 1)
                                ]),
                                _: 1
                              }, 8, ["rules"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_component_el_divider),
        _createVNode(_component_el_form_item, { label: "商品介绍图" }, {
          default: _withCtx(() => [
            _hoisted_14,
            _createVNode(_component_el_upload, {
              action: "#",
              "list-type": "picture-card",
              "auto-upload": false,
              "file-list": _ctx.fileList,
              "on-change": _ctx.imageListOnChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_plus)
                  ]),
                  _: 1
                })
              ]),
              file: _withCtx(({ file }) => [
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    class: "el-upload-list__item-thumbnail",
                    src: file.url,
                    alt: ""
                  }, null, 8, _hoisted_15),
                  _createElementVNode("span", _hoisted_16, [
                    (!_ctx.disabled)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "el-upload-list__item-delete",
                          onClick: ($event: any) => (_ctx.handleRemove(file))
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_delete)
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_17))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["file-list", "on-change"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "商品类型",
          prop: "product_type",
          rules: _ctx.rules.product_type
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.product.product_type,
              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.product.product_type) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([{key: '常规商品', value: 'normal'}, {key: '常规盒中盒', value: 'box_normal'}, {key: '无限盒中盒', value: 'box_infinity'}, {key: '奖励包', value: 'reward_pack'}], (item) => {
                  return _createVNode(_component_el_option, {
                    label: item.key,
                    value: item.value,
                    key: item.value
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["rules"]),
        (_ctx.product.product_type && (_ctx.product.product_type == 'box_normal' || _ctx.product.product_type == 'box_infinity'))
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 4,
              label: "自动开启",
              prop: "auto_open"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: _ctx.product.auto_open,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.product.auto_open) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.product.product_type == 'reward_pack')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              _createVNode(_component_el_form_item, {
                label: "奖励最小值",
                prop: "reward_min",
                rules: _ctx.rules.reward_min
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.product['reward_min'],
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.product['reward_min']) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["rules"]),
              _createVNode(_component_el_form_item, {
                label: "奖励最大值",
                prop: "reward_max",
                rules: _ctx.rules.reward_max
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.product['reward_max'],
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.product['reward_max']) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["rules"])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.product.product_type && (_ctx.product.product_type == 'box_normal' || _ctx.product.product_type == 'box_infinity'))
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 6,
              label: "盒中盒赏品列表"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_vxe_button, {
                  type: "button",
                  status: "primary",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#kt_modal_new_box_item_info"
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_button, {
                  type: "button",
                  status: "primary",
                  onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.sortByPrice()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.product.product_type == 'box_normal' || _ctx.product.product_type == 'box_infinity')
          ? (_openBlock(), _createElementBlock("table", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedProductGifts(), (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (item._destroy != 1)
                      ? (_openBlock(), _createElementBlock("tr", {
                          key: item.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(item.brand) + " - " + _toDisplayString(item.product), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatPrice(item.recycle_price)), 1),
                          _createElementVNode("td", null, [
                            _createVNode(_component_el_input_number, {
                              modelValue: item.quantity,
                              "onUpdate:modelValue": ($event: any) => ((item.quantity) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_vxe_button, {
                              type: "button",
                              status: "primary",
                              onClick: ($event: any) => (_ctx.move_up(item))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_22
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_vxe_button, {
                              type: "button",
                              status: "primary",
                              onClick: ($event: any) => (_ctx.move_down(item))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_23
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_vxe_button, {
                              type: "button",
                              status: "primary",
                              onClick: ($event: any) => (_ctx.destroy_item(item))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_24
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.product.product_type == 'box_infinity')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 8,
              label: "商品池类型",
              prop: "pool_type",
              rules: _ctx.rules.pool_type
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.product.pool_type,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.product.pool_type) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([{key: '常规', value: 'normal'}, {key: '吃菜', value: 'eat'}, {key: '做菜', value: 'cook'}], (item) => {
                      return _createVNode(_component_el_option, {
                        label: item.key,
                        value: item.value,
                        key: item.value
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["rules"]))
          : _createCommentVNode("", true),
        (_ctx.product.product_type == 'box_normal' || _ctx.product.product_type == 'box_infinity')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 9,
              label: "预估价格",
              prop: "price"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  value: _ctx.avarage_price(),
                  readonly: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.product.product_type == 'box_normal' || _ctx.product.product_type == 'box_infinity')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 10,
              label: "总商品数量",
              prop: "total_quantity"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  value: _ctx.total_quantity(),
                  readonly: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_25
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
              default: _withCtx(() => [
                _hoisted_26
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rules", "model"]),
    _createVNode(_component_NewBoxItemInfoModal, { add_box_item_infos: _ctx.add_box_item_infos }, null, 8, ["add_box_item_infos"])
  ]))
}